import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';

export const StyledDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    minHeight: 'calc(100vh - 64px)',
    minWidth: 'calc(100vw - 64px)'
  }
});



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/FullScreenDialog/styles.js